import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectUser = createFeatureSelector('user');

export const selectUserSettings = createSelector(selectUser, (state: any) => state.settings);
